let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1vWFJ")).then(() => parcelRequire('kxlNJ'));